import React, { useState, useRef } from "react";
import { FaArrowLeft, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { PlaySounds } from "../../../functions/playSounds";
import axios from "axios";
import buildLink from "../../../urls";
import MessageAlert from "../../../components/messageAlert";
import Loader from "../../../components/loader";
import Select from "react-select";
import { getDetectedOrderType } from "../../../functions/getDetectedOrderType";
import { axiosServer } from "../../../axiosServer";

function OrderHistoryv2() {
  const history = useNavigate();
  const [orders, setOrders] = useState([]);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [orderType, setOrderType] = useState(null);
  const orderId = useRef(null);
  var host = window.location.host;

  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];

  const handleTrashClick = () => {
    orderId.current.value = "";
    orderId.current.focus();
  };

  async function getOrderHistory(e) {
    e.preventDefault();

    let detectedOrderType = orderType;

    if (host == "pda.ishtari.com" || host.startsWith("localhost") || host == "pda.ishtari.com.gh") {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(orderId.current.value);

      if (!success) {
        playErrorSound();
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setOrderType(type);
    }

    let order_type;

    if (host == "pda.ishtari.com" || host.startsWith("localhost") || host == "pda.ishtari.com.gh") {
      order_type = detectedOrderType === "return" ? 1 : 0;
    } else {
      order_type = orderType.value === "return" ? 1 : 0;
    }

    if (
      orderType == null &&
      host !== "pda.ishtari.com" &&
      host !== "pda.ishtari.com.gh" &&
      !host.startsWith("localhost")
    ) {
      playErrorSound();
      setShowMessageErr(true);
      setMessage("Order Type is Empty!");
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }

    if (orderId.current.value === "") {
      playErrorSound();
      setShowMessageErr(true);
      setMessage("Order ID is Empty!");
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
      return;
    }

    try {
      const order_id = orderId.current.value;
      setLoading(true);
      const url =
        buildLink("orderHistory") +
        `&order_id=${order_id}` +
        `&order_type=${order_type}`;
      const response = await axiosServer.get(url);

      if (response.data.success) {
        setLoading(false);
        playSuccessSound();
        setMessage("Order Found");
        setOrders(response.data.data.history);

        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      } else {
        setLoading(false);
        playErrorSound();
        setMessage(response?.data?.message);
        setShowMessageErr(true);
        setTimeout(() => setShowMessageErr(false), 3000);
      }
    } catch (err) {
      setLoading(false);
      playErrorSound();
      setShowMessageErr(true);
      setMessage(err?.response?.data?.message);
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 3000);
    }
  }

  return (
    <>
      <div className=" h-full bg-white">
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl my-auto">Order Status History</h2>
            </div>
          </div>
        </div>
        <div className="container flex flex-col gap-5">
          <form
            onSubmit={(e) => getOrderHistory(e)}
            className="flex flex-col gap-3"
          >
            {host !== "pda.ishtari.com" && !host.startsWith("localhost") && host !== "pda.ishtari.com.gh" && (
              <div>
                <div className="mb-1">Order Type</div>
                <Select
                  placeholder="Order Type"
                  value={orderType}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "6px",
                      borderColor: state.isFocused ? "#888" : "#ccc",
                      padding: "4px",
                      boxShadow: "none",
                    }),
                  }}
                  onChange={(selected) => setOrderType(selected)}
                  options={options}
                />
              </div>
            )}
            <div>
              <div>Order ID</div>

              <div className="flex w-full gap-2">
                <div className="relative w-full flex items-center mt-2">
                  <input
                    ref={orderId}
                    name="order_id"
                    type="text"
                    placeholder="Order ID"
                    className="border border-dlabelColor outline-dbase w-full rounded-md py-2 pr-8 pl-2 text-d18"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        getOrderHistory(e);
                      }
                    }}
                  />
                  <FaTrash
                    className="absolute right-3 text-gray-400 hover:text-red-500 cursor-pointer transition-opacity duration-200 opacity-50"
                    onClick={() => handleTrashClick()}
                  />
                </div>

                <button
                  type="submit"
                  className="h-11 mt-2 px-4 rounded-md bg-dbase text-white text-sm font-medium hover:opacity-90 transition"
                >
                  <div className="flex items-center gap-2">
                    {loading ? <Loader /> : "Fetch"}
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className=" container flex flex-col gap-2  mt-5">
          {orders && orders.length > 0 && (
            <table className="min-w-full table-auto border-collapse border border-gray-200">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 border border-gray-200 text-left">
                    Username
                  </th>
                  <th className="px-4 py-2 border border-gray-200 text-left">
                    Status
                  </th>
                  <th className="px-4 py-2 border border-gray-200 text-left">
                    Date Added
                  </th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border border-gray-200">
                      {order.username}
                    </td>
                    <td className="px-4 py-2 border border-gray-200 font-bold">
                      {order.status}
                    </td>
                    <td className="px-4 py-2 border border-gray-200">
                      {order.date_added}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <MessageAlert
        message={message}
        type={showMessgErr ? "err" : "succ"}
        showMessg={showMessgErr || (showMessgSucc && true)}
      />
    </>
  );
}

export default OrderHistoryv2;
